module.exports = __webpack_public_path__ + "static/img/user-comment3.ac99906.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/user-comment3.png
// module id = mxfO
// module chunks = 0